import { contatos_empty } from "@/components/Form/Contatos/get_contacts_empty.js";
import { endereco_empty } from "@/components/Form/Endereco/get_endereco_empty.js";
import store from "@/store";

export const getPagination = ({ pagination }) => pagination;
export const conselho_empty = () => ({
  sigla: "",
  nome: "",
  descricao: "",
  atribuicoes: "",
  lei_criacao: "",
  link_lei: "",
  regimento_interno: "",
  objetivos: "",
  constituicao: "",
  endereco: endereco_empty(),
  contatos: contatos_empty(),
  imagem: {
    image_file: null,
    legenda: "",
    tags: null,
  },
  arquivos: [],
  layout: {
    traducoes: {
      descricao: "Descrição",
      objetivos: "Objetivos",
      atribuicoes: "Atribuições",
      constituicao: "Constituição",
      regime_interno: "Regime Interno",
    },
  },
  usuarios: [],
  config: configDefault(),
});
export const configDefault = () => ({
  descricao: "Descrição",
  objetivos: "Objetivos",
  atribuicoes: "Atribuições",
  constituicao: "Constituição",
  regime_interno: "Regime Interno",
});

export const menuDefault = () => ({
  home: {
    ativo: false,
    label: "Início",
  },
  contatos: {
    ativo: false,
    label: "Contato",
  },
  comissoes: {
    ativo: false,
    label: "Comissões",
  },
  conselhos: {
    ativo: false,
    label: "Conselho",
    submenus: {
      sobre: {
        ativo: false,
        label: "Sobre o Conselho",
      },
      mesadiretora: {
        ativo: false,
        label: "Mesa Diretora",
      },
      conselheiros: {
        ativo: false,
        label: "Conselheiros",
      },
      secretaria: {
        ativo: false,
        label: "Secretaria Executiva",
      },
    },
  },
  plenarias: {
    ativo: false,
    label: "Plenárias",
  },
  bibliotecas: {
    ativo: false,
    label: "Biblioteca",
  },
});

export const getUrlByConselho = () => {
  const prefix = "http://";
  const listUrl = store.getters["auth/GetUrlClient"] || [];
  const urlClient = listUrl[0];

  return (conselho = {}) => {
    const sigla = String(conselho.sigla).toLowerCase();
    return `${prefix}${sigla}.${urlClient}`;
  };
};

export const getUrlConselho = ({ conselho }) => {
  const baseUrlConselho = getUrlByConselho();
  return baseUrlConselho(conselho);
};
